import { useState } from 'react';
import { DiffRange, LocalParagraphScore, ParagraphLLMFeedback } from '../../db/indexedDb';

type Props = {
  score: LocalParagraphScore;
  reference: string;
  llmFeedback?: ParagraphLLMFeedback | null;
  llmState?: 'idle' | 'pending' | 'ready' | 'error';
};

// 和听力一致的 diff 渲染
const renderDiff = (ranges: DiffRange[]) =>
  ranges.map((range, index) => {
    if (range.kind === 'hit')
      return (
        <span className="diff-chip hit" key={`diff-${index}`}>
          {range.text}{' '}
        </span>
      );
    if (range.kind === 'typo')
      return (
        <span
          className="diff-chip typo"
          key={`diff-${index}`}
          title={`拼写错误: ${range.actual} → ${range.text}`}
        >
          {range.text}{' '}
        </span>
      );
    if (range.kind === 'missing')
      return (
        <span className="diff-chip missing" key={`diff-${index}`}>
          {range.text}{' '}
        </span>
      );
    if (range.kind === 'extra')
      return (
        <span className="diff-chip extra" key={`diff-${index}`}>
          {range.text}{' '}
        </span>
      );
    return (
      <span className="diff-chip" key={`diff-${index}`}>
        {range.text}{' '}
      </span>
    );
  });

function ParagraphRecallResult({ score, reference, llmFeedback, llmState = 'idle' }: Props) {
  const [showRef, setShowRef] = useState(false);

  return (
    <div className="recall-result">
      {/* 覆盖度进度条 - 和听力一致 */}
      <div className="coverage-row">
        <div className="coverage-bar" aria-label="覆盖率">
          <span className="coverage-fill" style={{ width: `${score.coverage}%` }} />
        </div>
        <span className="coverage-label">覆盖率 {score.coverage}%</span>
      </div>

      {/* 错误高亮 - 和听力一致 */}
      <div className="recall-block">
        <p className="section-label">错误高亮（漏写 / 多写）</p>
        <div className="diff-panel">{renderDiff(score.diffRanges)}</div>
      </div>

      {/* 遗漏短语 */}
      {score.missingUnits.length > 0 && (
        <div className="recall-block">
          <p className="section-label">漏掉的词</p>
          <div style={{ color: 'var(--accent-red)' }}>
            {score.missingUnits.slice(0, 6).join(', ')}
            {score.missingUnits.length > 6 && ` +${score.missingUnits.length - 6}`}
          </div>
        </div>
      )}

      {/* AI 反馈 */}
      {llmState === 'pending' && (
        <div className="recall-block">
          <p className="section-label">AI 讲解</p>
          <p className="hint">生成中…</p>
        </div>
      )}
      {llmState === 'ready' && llmFeedback && (
        <div className="recall-block">
          <p className="section-label">AI 讲解</p>
          <div className="ai-panel">
            <ul className="recall-list">
              {llmFeedback.suggestions.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {/* 原文对照（可展开）- 和听力一致 */}
      <div className="recall-actions">
        <button
          type="button"
          className="session-action neutral"
          onClick={() => setShowRef(!showRef)}
        >
          {showRef ? '隐藏原文' : '显示原文'}
        </button>
      </div>
      {showRef && (
        <div className="recall-block">
          <p className="section-label">原文对照</p>
          <p className="session-body">{reference || '文本待加载'}</p>
        </div>
      )}
    </div>
  );
}

export default ParagraphRecallResult;

